export const auth0Messages = {
  failedToVerifyCode: 'Failed to verify code verifier',
  userAlreadyInSession: 'Invalid state',
  wrongEmailOrVerification: 'Wrong email or verification code.',
};
